import waitlist from "./waitlist";
import merch from "./merch";
import config from "./config";

const api = { waitlist, merch, config }
export default api;
